import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CanvasJSChart } from './canvasjs-angular-charts.component';


@NgModule({
  declarations: [ CanvasJSChart ],
  imports: [
    CommonModule
  ],
  exports: [ CanvasJSChart ]
})
export class CanvasJSAngularChartsModule { }